<template>
  <section id="talk">
    <base-card>
      <v-card-title :class="[$vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1']"
                    class="justify-center font-weight-bold grey--text text--darken-3 mb-3 text-center">
        {{$t('panel.home.content.title')}}
      </v-card-title>
      <v-card-text class="text-left text-md-center title font-weight-light mx-auto mb-5">
        {{$t('panel.home.content.description')}}
      </v-card-text>

      <v-container>
        <v-row>
          <v-col v-for="(feature, i) in features"
                 :key="i"
                 cols="12"
                 md="4"
                 sm="6">
            <div class="text-center">
              <v-icon :color="feature.color"
                      :size="64"
                      class="mb-3"
                      v-text="feature.icon" />
              <p class="text-justify text-md-center"
                 v-text="feature.text" />
            </div>
          </v-col>
        </v-row>
      </v-container>

      <v-divider class="my-5 mx-3" />

      <v-card-title :class="[$vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1']"
                    class="justify-center font-weight-bold grey--text text--darken-3 mb-3">
        {{$t('panel.home.contact.title')}}
      </v-card-title>

      <v-card-text class="text-left text-md-center title font-weight-light mx-auto mb-5">
        {{$t('panel.home.contact.message')}}
      </v-card-text>

      <v-card-text>
        <v-form>
          <v-container class="px-0">
            <v-row>
              <v-col cols="12"
                     md="6">
                <v-text-field :label="$t('field.fullName')"
                              outlined
                              v-model="name"
                              :error-messages="validationNameError"
                              @input="$v.name.$touch()"
                              @blur="$v.name.$touch()" />
              </v-col>
              <v-col cols="12"
                     md="6">
                <v-text-field :label="$t('field.email')"
                              outlined
                              v-model="email"
                              type="email"
                              :error-messages="validationEmailError"
                              @input="$v.email.$touch()"
                              @blur="$v.email.$touch()" />
              </v-col>
              <v-col cols="12">
                <v-textarea :label="$t('field.message')"
                            outlined
                            rows="12"
                            v-model="message"
                            :error-messages="validationMessageError"
                            @input="$v.message.$touch()"
                            @blur="$v.message.$touch()" />
              </v-col>

              <v-col cols="12">
                <vue-recaptcha :sitekey="recaptchaKey"
                               :loadRecaptchaScript="true"
                               @verify="onVerify"
                               @expired="onExpired">
                </vue-recaptcha>
              </v-col>

              <v-col cols="12">
                <v-btn :block="$vuetify.breakpoint.smAndDown"
                       :disabled="dialog || !isCaptchaValid"
                       :loading="dialog"
                       class="font-weight-light"
                       color="primary"
                       large
                       @click="sendEmail()">
                  {{$t('button.sendMessage')}}

                  <!-- :disabled="!isCaptchaValid" -->
                </v-btn>

                <!-- <v-btn :block="$vuetify.breakpoint.smAndDown"
                         class="font-weight-light"
                         color="primary"
                         large
                         @click="sendEmail()">
                    {{$t('button.sendMessage')}}
                  </v-btn> -->

              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </base-card>

    <v-dialog v-model="dialog"
              hide-overlay
              persistent
              width="300">
      <v-card color="primary"
              dark>
        <v-card-text>
          {{$t('dialog.sendingEmail')}}
          <v-progress-linear indeterminate
                             color="white"
                             class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </section>

</template>

<script>
  import { required, minLength, email } from "vuelidate/lib/validators";
  import UtilsService from "../../services/UtilsService";
  import VueRecaptcha from "vue-recaptcha";

  export default {
    name: "HomeContents",

    /******************************************
     *                Components              *
     ******************************************/
    components: {
      VueRecaptcha,
    },

    /******************************************
     *                 Computed               *
     ******************************************/
    computed: {
      recaptchaKey: function () {
        return process.env.NODE_ENV === "production"
          ? "6LeQocoZAAAAAIUcF1Dvr9pnu4eOPahw9QqQt_iT"
          : "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";
      },

      features: function () {
        const data = [
          {
            icon: "mdi-widgets",
            color: "light-blue",
            text: this.$i18n.t("panel.home.content.featSoftware"),
          },
          {
            icon: "mdi-database",
            color: "orange",
            text: this.$i18n.t("panel.home.content.featDb"),
          },
          {
            icon: "mdi-message-text",
            color: "indigo",
            text: this.$i18n.t("panel.home.content.featConseil"),
          },
        ];

        return data;
      },

      /**
       * Generate error for NAME
       */
      validationNameError() {
        const errors = [];

        if (!this.$v.name.$dirty) {
          return errors;
        }

        if (!this.$v.name.required) {
          errors.push(
            this.$i18n.t("error.required", {
              field: this.$i18n.t("field.fullName"),
            })
          );
        }
        if (!this.$v.name.minLength) {
          errors.push(
            this.$i18n.t("error.minLength", {
              field: this.$i18n.t("field.fullName"),
              lenght: 4,
            })
          );
        }

        return errors;
      },

      /**
       * Generate error for Email
       */
      validationEmailError() {
        const errors = [];

        if (!this.$v.email.$dirty) {
          return errors;
        }

        if (!this.$v.email.required) {
          errors.push(this.$i18n.t("error.email.required"));
        }
        if (!this.$v.email.email) {
          errors.push(this.$i18n.t("error.email.email"));
        }

        return errors;
      },

      /**
       * Generate error for Message
       */
      validationMessageError() {
        const errors = [];

        if (!this.$v.message.$dirty) {
          return errors;
        }

        if (!this.$v.message.required) {
          errors.push(
            this.$i18n.t("error.required", {
              field: this.$i18n.t("field.message"),
            })
          );
        }
        if (!this.$v.message.minLength) {
          errors.push(
            this.$i18n.t("error.minLength", {
              field: this.$i18n.t("field.message"),
              lenght: 10,
            })
          );
        }

        return errors;
      },
    },

    /******************************************
     *                   Validations                 *
     ******************************************/
    validations: {
      name: {
        required,
        minLength: minLength(4),
      },
      email: {
        required,
        email,
      },
      message: {
        required,
        minLength: minLength(10),
      },
    },
    /******************************************
     *                   Data                 *
     ******************************************/
    data: () => ({
      name: undefined,
      email: undefined,
      message: undefined,

      dialog: false,

      // name: "Testeur",
      // email: "test@test.org",
      // message: "un message bidon",

      isCaptchaValid: false,
      //showRecaptcha: false,
      //
      //  "mdi-face-agent",
    }),

    /******************************************
     *                 Methods                *
     ******************************************/
    methods: {
      /**
       * Check valid fields to send mail
       */
      checkIsValid() {
        this.$v.$touch();
        return !this.$v.$invalid;
      },

      onVerify: function (response) {
        // console.log("Verify: " + response);
        this.isCaptchaValid = this.isCaptcha2Valid(response);
      },

      onExpired: function () {
        // console.log("Expired");
        this.isCaptchaValid = false;
      },

      /**
       * Check if user validate captcha correctly
       */
      async isCaptcha2Valid(token) {
        try {
          var result = await UtilsService.captcha2({
            response: token,
          });

          // console.log("result: ", result);

          if (result.data.success == true) {
            // console.log("captcha v2 success");
            return true;
          } else {
            // console.log("captcha v2 failed");
            return false;
          }
        } catch (error) {
          // console.log("error: ", error);
          return false;
        }
      },

      /**
       * Check if user validate captcha correctly
       */
      async isCaptcha3Valid() {
        // (optional) Wait until recaptcha has been loaded.
        await this.$recaptchaLoaded();

        // Execute reCAPTCHA with action "login".
        const token = await this.$recaptcha("login");
        //console.log("token recaptcha: ", token);

        try {
          var result = await UtilsService.captcha3({
            response: token,
          });

          this.showRecaptcha = false;

          if (result.data.success == true) {
            console.log("captcha success");
          } else {
            console.log("captcha failed");
            return false;
          }
        } catch (error) {
          console.log("error: ", error);
          return false;
        }

        return true;
      },

      /**
       * Send the email if all fields are valids
       */
      async sendEmail() {
        if (!this.checkIsValid()) {
          // console.log("invalid fields!!!");
          return;
        }

        // var result = await UtilsService.testLocal();
        // console.log("UtilsService.test(): ", result);

        // test Recaptcha V2
        // if (!(await this.isCaptcha2Valid())) {
        //   console.log("captcha invalid");
        //   return;
        // }

        // test Recaptcha V3
        // if (!(await this.isCaptcha3Valid())) {
        //   console.log("captcha invalid");
        //   return;
        // }

        this.dialog = true;

        try {
          var result = await UtilsService.sendMail({
            name: this.name,
            email: this.email,
            message: this.message,
          });

          if (result.data.success == true) {
            // console.log("send mail success");
            this.name = undefined;
            this.email = undefined;
            this.message = undefined;

            this.$v.$reset();
          } else {
            // console.log("send mail  failed");
          }
        } catch (error) {
          // console.log("error: ", error);
        }

        this.dialog = false;
      },
    },

    /******************************************
     *                 Mounted                *
     ******************************************/
    mounted() {},

    watch: {},
  };
</script>
